import * as React from "react";

interface DislikeIconProps {
  className?: string;
  style?: React.CSSProperties;
}

export const DislikeIcon: React.FC<DislikeIconProps> = ({ className, style }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0.1"
    viewBox="0 0 24 24"
    height="0.8em"
    width="0.8em"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <path d="M20 3H6.693A2.01 2.01 0 0 0 4.82 4.298l-2.757 7.351A1 1 0 0 0 2 12v2c0 1.103.897 2 2 2h5.612L8.49 19.367a2.004 2.004 0 0 0 .274 1.802c.376.52.982.831 1.624.831H12c.297 0 .578-.132.769-.36l4.7-5.64H20c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-8.469 17h-1.145l1.562-4.684A1 1 0 0 0 11 14H4v-1.819L6.693 5H16v9.638L11.531 20zM18 14V5h2l.001 9H18z"></path>
  </svg>
);

export default DislikeIcon;
